"use client";
import { useEffect } from 'react';
import styles from './styles.module.scss';

const HubspotForm = props => {
    const {portalId, formId} = props || {};
    useEffect(()=>{
      const loadHubspotForm = () => {
        console.log("loaded");
          if (window?.hbspt) {
            console.log("window present");
              try {
                console.log("trying");
                  window.hbspt.forms.create({
                      region: "na1",
                      portalId: portalId,
                      formId: formId,
                      target: "#hubspotForm"
                  });
              } catch (error) {
                  console.error("Error creating HubSpot form:", error);
              }
          }
      };
      loadHubspotForm();
    }, [])


    return(
      <>
        <section className={styles.hubspotForm}>
            <div className="container">
                <div id="hubspotForm" className={`hsForm`}></div>
            </div>
        </section>
      </>
    );
}

export default HubspotForm;
